var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1e53;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.9,30.55a4.38,4.38,0,1,0,4.37-4.38,4.37,4.37,0,0,0-4.37,4.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.35,30.55a4.38,4.38,0,1,0,4.38-4.38,4.37,4.37,0,0,0-4.38,4.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.08,30.55a4.38,4.38,0,1,0,8.75,0h0a4.38,4.38,0,1,0-8.75,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.8,30.55a4.38,4.38,0,1,0,4.38-4.38,4.37,4.37,0,0,0-4.38,4.38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.45,40.27a4.38,4.38,0,1,0,4.37-4.37,4.37,4.37,0,0,0-4.37,4.37h0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.17,40.27a4.38,4.38,0,1,0,4.38-4.37,4.38,4.38,0,0,0-4.38,4.37h0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.35,40.27a4.38,4.38,0,1,0,4.38-4.37,4.38,4.38,0,0,0-4.38,4.37h0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.08,40.27a4.38,4.38,0,0,0,8.75,0h0a4.38,4.38,0,0,0-8.75,0h0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.17,50a4.38,4.38,0,1,0,4.38-4.38A4.38,4.38,0,0,0,26.17,50h0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.9,50a4.38,4.38,0,1,0,4.37-4.38A4.38,4.38,0,0,0,35.9,50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.62,50A4.38,4.38,0,1,0,50,45.62,4.38,4.38,0,0,0,45.62,50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.35,50a4.38,4.38,0,1,0,4.38-4.38A4.38,4.38,0,0,0,55.35,50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.8,50a4.38,4.38,0,1,0,4.38-4.38A4.38,4.38,0,0,0,74.8,50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.45,59.73a4.38,4.38,0,1,0,4.37-4.38,4.37,4.37,0,0,0-4.37,4.38h0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.17,59.73a4.38,4.38,0,1,0,4.38-4.38,4.38,4.38,0,0,0-4.38,4.38h0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.35,59.73a4.38,4.38,0,1,0,4.38-4.38,4.38,4.38,0,0,0-4.38,4.38h0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.17,69.45a4.38,4.38,0,1,0,4.38-4.37,4.38,4.38,0,0,0-4.38,4.37h0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.9,69.45a4.38,4.38,0,1,0,4.37-4.37,4.38,4.38,0,0,0-4.37,4.37h0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.62,69.45A4.38,4.38,0,1,0,50,65.08a4.38,4.38,0,0,0-4.38,4.37h0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.8,69.45a4.38,4.38,0,1,0,4.38-4.37,4.38,4.38,0,0,0-4.38,4.37h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.85f58df4bbdf2b89b5f1dc81b98d0647.svg";
export { ForwardRef as ReactComponent };